<template>
    <ModalComponent name="listadoPartidos" title="Listado de partidos para liberar su asiento">
        <ContentOrLoading>
            <b-table striped hover :show-empty="true" :items="partidos" :fields="fields" v-if="partidos">
                <template #empty="">
                    <h5 class="text-center">No hay ningún evento disponible para liberar/recuperar su asiento.</h5>
                </template>
                <template #cell(liberado)="{ item }">
                    <span v-if="item.liberado" class="ml-4"><i class="text-green fas fa-check-circle"></i></span>
                    <span v-else class="ml-4"><i class="text-danger fas fa-times-circle"></i></span>
                </template>
                <template #cell(liberar)="{ item }">
                    <Button @click="liberarAsiento(item)" :disabled="loading">{{ item.liberado ? 'RECUPERAR' : 'LIBERAR' }}</Button>
                </template>
            </b-table>
        </ContentOrLoading>
    </ModalComponent>
</template>

<script>
import ModalComponent from '@/components/backend/components/ModalComponent';

export default {
    props: ['abono'],
    data() {
        return {
            partidos: null,
            loading: false,
            fields: [
                { key: "nombre", label: "Partido" },
                { key: "liberado", label: "Liberado" },
                { key: "liberar", label: "", class: 'text-center' }
            ]
        }
    },
    methods: {
        getPartidos() {
            this.loading = true;

            let params = {
                filters: {
                    n_abonado: this.abono?.attributes?.NumSocio,
                    id_persona: this.abono?.persona_info?.id_persona,
                    pin: this.abono?.persona_info?.pin,
                    tid: this.configuracion.hash_teatro
                },
            }

            this.$store.dispatch(this.config.getVuexAlias('lfp.abono.liberar.partidos'), params).then(res => {
                this.partidos = res.data.data;
            }).catch(error => {
                console.log(error);
                this.$toast.error(error.response?.data?.message);
            }).finally(() => {
                this.loading = false;                 
            });
        },
        liberarAsiento(partido) {
            this.loading = true;

            let url = null;

            if (partido.liberado) {
                url = 'lfp.abono.asiento.recuperar';
            } else {
                url = 'lfp.abono.asiento.liberar';
            }

            let params = {
                filters: {
                    n_abonado: this.abono?.attributes?.NumSocio,
                    id_persona: this.abono?.persona_info?.id_persona,
                    pin: this.abono?.persona_info?.pin,
                    tid: this.configuracion.hash_teatro
                },
                partido_id: partido.id
            }

            this.$store.dispatch(this.config.getVuexAlias(url), params).then(res => {
                this.$toast.success(res.data?.message);
                this.$emit('close');
                this.getPartidos();
            }).catch(error => {
                console.log(error);
                this.$toast.error(error.response?.data?.message);
            }).finally(() => {
                this.loading = false;                 
            });
        }
    },
    computed: {
        configuracion() {
            return this.$store.getters.getConfig;
        }
    },
    components: {
        ModalComponent
    }
}
</script>